<div class="nav-item-content d-flex align-items-baseline">
  <div class="icon-info-display align-items-baseline d-flex">
    <div>
      <img
        class="submission-file-icon"
        src="\assets\images\file-icon.svg"
        alt="file img"
      />
    </div>
    <div>
      <h4
        class="eclipse-content no-break no-scroll"
        [ddsTooltip]="item.submissionTitle"
      >
        {{ item.submissionTitle }}
      </h4>
      <div class="sub-info d-flex font-size-12 align-items-center">
        <span
          class="item-type d-flex align-items-center justify-content-center"
          >{{ item.submissionTypeCode }}</span
        >
        <span
          class="status-padding d-flex"
          [style.color]="
            transformStatus(item.submissionStatusName) | statusStyle : 'color'
          "
          [style.backgroundColor]="
            transformStatus(item.submissionStatusName)
              | statusStyle : 'backgroundColor'
          "
          >{{ item.submissionStatusName }}</span
        >
      </div>
    </div>
  </div>
  <div
    (click)="onShowMore()"
    class="show-more font-size-12 cursor-clickable dds-header__container justify-content-flex-end"
  >
    <span class="font-weight-normal">See more </span>
    <span>
      <img src="\assets\images\Right icon.png" alt="right arrow" />
    </span>
  </div>
</div>

<div class="margin-left-m" *ngIf="!isSubmissionDataLoading">
  <div>
    <div
      *ngIf="!item.isFormCompleted && !isPendingCloseoutVisible()"
      class="styled-box label-expand font-size-12"
    >
      <span>Complete required action(s)</span>
    </div>

    <div *ngIf="item.isFormCompleted">
      <div *ngIf="isSubmitBtnVisible() || isResubmitBtnVisibleForSummary()">
        <div *ngIf="!updateSubmitButtonStatus()">
          <div
            *ngIf="checkForSelfReviewEligibilityStatus()"
            class="d-flex btn-gap"
          >
            <dds-button
              [size]="smallButton.size ?? ''"
              [width]="smallButton.width ?? ''"
              [ariaLabel]="'Self-review'"
              (clicked)="submitCommonSectionDataForSummary()"
            >
              Self-review
            </dds-button>

            <dds-button
              [size]="smallButton.size ?? ''"
              [width]="smallButton.width ?? ''"
              [theme]="smallButton.theme ?? ''"
              [kind]="smallButton.kind ?? ''"
              [ariaLabel]="'Opt out of self-review'"
              (clicked)="openDocumentEditModel()"
            >
              Opt out of self-review
            </dds-button>
          </div>
          <div>
            <dds-button
              *ngIf="
                isSubmitBtnVisible() && !checkForSelfReviewEligibilityStatus()
              "
              [size]="smallButton.size ?? ''"
              [width]="smallButton.width ?? ''"
              [ariaLabel]="'Submit'"
              (click)="submitCommonSectionDataForSummary()"
            >
              Submit
            </dds-button>

            <dds-button
              *ngIf="
                isResubmitBtnVisibleForSummary() &&
                !checkForSelfReviewEligibilityStatus()
              "
              (clicked)="onclickResubmitForReviewBtnForSummary()"
              [size]="smallButton.size ?? ''"
              [ariaLabel]="'Resubmit'"
              [width]="smallButton.width ?? ''"
            >
              Resubmit
            </dds-button>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="isSubmittedResubmittedSectionVisible()">
      <dds-button
        (click)="onShowMore()"
        [size]="smallButton.size ?? ''"
        [width]="smallButton.width ?? ''"
        [ariaLabel]="'Complete review'"
        [disabled]="
          !this.permissionObj['Intake_Submission_CompleteReviewBtn_Enable']
        "
        >Complete review</dds-button
      >
    </div>
    <div>
      <div *ngIf="isPendingCloseoutVisible()" class="d-flex flex-wrap btn-gap">
        <dds-button
          [size]="smallButton.size ?? ''"
          [kind]="'primary'"
          [width]="smallButton.width ?? ''"
          [ariaLabel]="'Resubmit for review'"
          (clicked)="onResubmitForReview()"
          ><span
            *ngIf="
              submissionStatus === submissionStatusSelfPendingCloseout ||
              submissionStatus === submissionStatusIncompletePendingCloseout
            "
            >Resubmit</span
          >
          <span *ngIf="submissionStatus === submissionStatusRMPendingCloseout"
            >Access reviewed document(s) / Resubmit</span
          ></dds-button
        >
        <dds-button
          [size]="smallButton.size ?? ''"
          [kind]="'primary'"
          [width]="smallButton.width ?? ''"
          [ariaLabel]="'Archive / Finalize submission'"
          (clicked)="onclickArchiveAndCompleteBtnForSummary()"
          >Archive / Finalize submission</dds-button
        >
      </div>
    </div>
  </div>
</div>

<hr class="eclipse-small-header-grey" />
